import React from "react";
import Section, { FadeIn } from "@/components/Section";
import { BRAND } from "@/lib/brand";

export default function DatenschutzPage() {
  return (
    <div data-testid="datenschutz-page" className="pt-36 lg:pt-44">
      <Section padded={false} className="pb-32">
        <FadeIn>
          <div className="max-w-3xl">
            <div className="overline mb-6">Rechtliches</div>
            <h1 className="font-display text-5xl lg:text-6xl tracking-[-0.02em] text-white leading-[1.02]">
              Datenschutzerklärung
            </h1>
            <p className="mt-8 text-white/60 text-[15.5px] leading-relaxed max-w-2xl">
              Der Schutz Ihrer persönlichen Daten ist mir wichtig. Auf dieser
              Seite informiere ich Sie transparent darüber, welche Daten
              verarbeitet werden und zu welchem Zweck.
            </p>

            <div className="mt-16 space-y-12 text-white/70 text-[15.5px] leading-relaxed">
              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  1. Verantwortliche Stelle
                </h2>
                <p>
                  {BRAND.company} — {BRAND.name}
                  <br />
                  {BRAND.address.street}, {BRAND.address.city}
                  <br />
                  Telefon: {BRAND.phone}
                  <br />
                  E-Mail: {BRAND.email}
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  2. Erfassung & Verarbeitung allgemeiner Informationen
                </h2>
                <p>
                  Beim Aufruf dieser Website werden automatisch technische
                  Informationen allgemeiner Natur erfasst (Browsertyp,
                  Betriebssystem, Referrer-URL, IP-Adresse, Uhrzeit der
                  Anfrage). Diese Daten erlauben keine Rückschlüsse auf Ihre
                  Person und werden ausschließlich zur Gewährleistung eines
                  störungsfreien Betriebs der Seite genutzt.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  3. Kontakt- und Terminanfrage-Formular
                </h2>
                <p>
                  Wenn Sie mir über das Kontakt- oder Terminanfrage-Formular
                  eine Anfrage übermitteln, werden Ihre Angaben (Name, E-Mail,
                  ggf. Telefon, Wunschtermin, Nachricht) zur Bearbeitung der
                  Anfrage und für den Fall von Anschlussfragen gespeichert.
                  Diese Daten gebe ich nicht ohne Ihre Einwilligung weiter.
                  Rechtsgrundlage ist Art. 6 Abs. 1 lit. b bzw. lit. f DSGVO.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  4. Speicherdauer
                </h2>
                <p>
                  Ihre Daten werden so lange gespeichert, wie es für die
                  Zweckerfüllung (Bearbeitung Ihrer Anfrage, ggf.
                  Vertragserfüllung) erforderlich ist – oder solange
                  gesetzliche Aufbewahrungsfristen bestehen.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  5. Cookies
                </h2>
                <p>
                  Diese Website verwendet ausschließlich technisch notwendige
                  Funktionen. Es werden standardmäßig keine Tracking-Cookies
                  oder Analysedienste von Drittanbietern eingesetzt.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  6. Ihre Rechte
                </h2>
                <p>
                  Sie haben jederzeit das Recht auf Auskunft, Berichtigung,
                  Löschung oder Einschränkung der Verarbeitung Ihrer Daten
                  sowie ein Recht auf Datenübertragbarkeit und Widerspruch.
                  Darüber hinaus steht Ihnen ein Beschwerderecht bei der
                  zuständigen Aufsichtsbehörde zu.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-white tracking-tight mb-3">
                  7. Kontakt in Datenschutzfragen
                </h2>
                <p>
                  Anfragen zum Datenschutz richten Sie bitte an:{" "}
                  <a href={`mailto:${BRAND.email}`} className="link-underline text-white">
                    {BRAND.email}
                  </a>
                </p>
              </section>

              <div className="pt-6 border-t border-white/[0.08] text-white/45 text-[13px] italic">
                Hinweis: Dieser Datenschutz-Text ist ein sorgfältig erstellter
                Entwurf. Bitte lassen Sie die finale Fassung vor
                Veröffentlichung von einer fachkundigen Stelle prüfen —
                insbesondere falls zusätzliche Tools, Analysedienste oder
                eingebettete Inhalte ergänzt werden.
              </div>
            </div>
          </div>
        </FadeIn>
      </Section>
    </div>
  );
}
